
import { useState, useRef, Fragment } from "react";
import Config from "../Config";
import InputComboGrupa from "./InputComboGrupa";
import InputTextAlpha from "./InputTextAlpha";
import InputComboStawkiWyzMulti from "./InputComboStawkiWyzMulti";
import InputCombo from "./InputCombo";
import gopresent from "../gopresent.png";





function InputKidsMulti(props)
{

    var defStanUmowy = '1';
    if(props.stan_umowy != undefined) defStanUmowy = props.stan_umowy;


    const [filterParam, setFilterParam] = useState({
        imie: props.mainView.readFilter('imie',''), 
        nazwisko:  props.mainView.readFilter('nazwisko',''),  

        imie_r: props.mainView.readFilter('imie_r',''), 
        nazwisko_r:  props.mainView.readFilter('nazwisko_r',''),  

        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'), 

        zawiera_stawke: '',
        niezawiera_stawki: '',

        archiwalne: '0',

        stan_umowy: defStanUmowy,
    });


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);


    var max = 1000;
    if(props.max != undefined && props.max != null) max = props.max;

    const [maxKids,setMaxKids] = useState(max);

    const [tabSelected, setTabSelected] = useState([
       
    ]);


    const [view, setView] = useState('btn');


    const getTab = () => {
            
        
        props.mainView.setProgress(-2);

    

        fetch( Config.url + '/rest_v1_calc,kids', {
            method: 'POST', 
            body: '', 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {                                              
                        setTab(res.result);                                         
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;
    }


    const reviewKid = (e) =>
        {
            var id        = e.target.getAttribute("id");
            var imie      = e.target.getAttribute("imie");
            var nazwisko  = e.target.getAttribute("nazwisko");
    
            props.mainView.openKid( id, imie, nazwisko );
        }



    const changeView = (e) => {

    
        if(e != null)
        {
           var atrName = e.currentTarget.getAttribute("name");
           if(atrName != null) return;
        }
  

        if(view == 'btn') {setView("dlg"); }  else setView('btn'); 
    } 


    const saveData = () => {


        var selected = new Array();

        for(var g=0; g < tab.length; g++)
            {                
                    for(var d=0; d < tab[g].dzieci.length; d++)
                        {
                                
                              if(tab[g].dzieci[d].param1 == '1')  {  

                                selected.push( tab[g].dzieci[d] );
                              };
                               
                        }   
                
            }

            setTabSelected(selected);
            changeView();

            if(props.onKidsSelected != undefined) props.onKidsSelected(selected);

    }


    const goSelect = (e) => {

        var p_grupa_id = e.target.getAttribute('p_grupa_id');
        var p_dziecko_id = e.target.getAttribute('p_dziecko_id');

        //console.log(p_grupa_id, p_dziecko_id);

        for(var g=0; g < tab.length; g++)
        {
            if(tab[g].id == p_grupa_id )
            {
                for(var d=0; d < tab[g].dzieci.length; d++)
                    {
                            if(tab[g].dzieci[d].id == p_dziecko_id )
                            {
                                if(tab[g].dzieci[d].param1 == '0')  {  tab[g].dzieci[d].param1 = '1' } else tab[g].dzieci[d].param1 = '0' ;
                            }else
                            {
                                if(maxKids == 1)    tab[g].dzieci[d].param1 = '0' ;
                            }
                    }   
            }else 
            if(maxKids == 1) {

                for(var d=0; d < tab[g].dzieci.length; d++)
                    {
                         tab[g].dzieci[d].param1 = '0' ;
                    } 
            }


        }

        var s = JSON.stringify(tab);
        setTab(JSON.parse(s));
       

    }


    const selectAll = (e) =>  {


        if(maxKids == 1) return;


        var fTab = getFilteredTab();

       // console.log("FTAB", fTab);


        var p_grupa_id = e.target.getAttribute('id');
        var txt        = e.target.innerHTML;


        var selectedDZ  = new Array();

        for(var kx = 0; kx < fTab.length; kx++ )
        {
            if(fTab[kx].id == p_grupa_id) selectedDZ = fTab[kx].dzieci;
        }


       // console.log("FTAB dz ", selectedDZ);

     
        if(txt == 'zaznacz')
        {
            e.target.innerHTML = 'odznacz';

            for(var g=0; g < tab.length; g++)
                {
                    if(tab[g].id == p_grupa_id )
                    {
                        for(var d=0; d < tab[g].dzieci.length; d++)
                            {           
                                    var isFiltered = false;

                                    for(var dzInx =0; dzInx < selectedDZ.length; dzInx++)
                                    {
                                        if(selectedDZ[dzInx].id ==  tab[g].dzieci[d].id ) isFiltered = true;
                                    }
                                
                                    if(isFiltered)
                                         tab[g].dzieci[d].param1 = '1';                                   
                            }   
                    }
                }

        }else
        {
            e.target.innerHTML = 'zaznacz';

            for(var g=0; g < tab.length; g++)
                {
                    if(tab[g].id == p_grupa_id )
                    {
                        for(var d=0; d < tab[g].dzieci.length; d++)
                            {
                                   
                                var isFiltered = false;

                                for(var dzInx =0; dzInx < selectedDZ.length; dzInx++)
                                {
                                       if(selectedDZ[dzInx].id ==  tab[g].dzieci[d].id ) isFiltered = true;
                                }
                                
                                if(isFiltered)
                                tab[g].dzieci[d].param1 = '0';
                                
                            }   
                    }
                }
        }

        //console.log("FTAB2", tab);
        var s = JSON.stringify(tab); 
        setTab(JSON.parse(s));
               
    }


 


    const valChangeListener = (filedName, val, correct, msg) => {

       //  console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );               
    }


    const goNextNew = () => {
        console.log("goNext");               
    }


    const getFilteredTab = () => {

        var rTab = new Array();


        console.log("X-getFilteredTab", tab);

        for(var k=0; k<tab.length; k++) //petla po grupach..
        {
         

            var nDz = new Array();         


            for(var d = 0; d < tab[k].dzieci.length; d++  )
            {
                var goAdd0 = true;
                var goAdd1 = true;
                var goAdd2 = true;
                var goAdd3 = true;
                var goAdd4 = true;
                var goAdd5 = true;

                var goAdd6 = true;
                var goAdd7 = true;

                var goAdd8 = true;


                var dz = tab[k].dzieci[d];


                if(filterParam.p_grupa_id != "_x_")
                {
                    goAdd0 = false;

                    if(tab[k].id == filterParam.p_grupa_id) goAdd0 = true;
                }


                if(filterParam.imie.length > 2)
                {
                    goAdd1 = false;

                    if(  dz.imie.toLowerCase().includes( filterParam.imie.toLowerCase() )  )
                    {
                            goAdd1 = true;
                    }
                }

                if(filterParam.nazwisko.length > 2)
                {
                        goAdd2 = false;
    
                        if(  dz.nazwisko.toLowerCase().includes( filterParam.nazwisko.toLowerCase() )  )
                        {
                                goAdd2 = true;
                        }
    
                }




                if(filterParam.imie_r.length > 2)
                    {
                            goAdd6 = false;
        
                            for(var r=0; r< dz.rodzice.length; r++) 
                            {
                                 var imieR = dz.rodzice[r].imie;   
                                 var nazwiskoR = dz.rodzice[r].nazwisko;   

                                 if(  imieR.toLowerCase().includes( filterParam.imie_r.toLowerCase() )  )
                                    {
                                            goAdd6 = true;
                                            break;
                                    }
                            }        
                    }

                    if(filterParam.nazwisko_r.length > 2)
                        {
                                goAdd7 = false;
            
                                for(var r=0; r< dz.rodzice.length; r++) 
                                {
                                     var imieR = dz.rodzice[r].imie;   
                                     var nazwiskoR = dz.rodzice[r].nazwisko;   
    
                                     if(  nazwiskoR.toLowerCase().includes( filterParam.nazwisko_r.toLowerCase() )  )
                                        {
                                                goAdd7 = true;
                                                break;
                                        }
                                }        
                        }


                if(filterParam.zawiera_stawke != "")
                {
                        goAdd3 = false;

                        if(dz.umowy.length == 0) { 
                            goAdd3 = false; // nie zawiera stawki.. bo nie ma umowy..
                        }else
                        {                            
                           
                            for(var uI=0; uI < dz.umowy.length; uI++)
                            {
                                    var umAll = true; //czy zawiera wszystnie niezbedne stawki...? domyslnie tak..
                                    var ids = filterParam.zawiera_stawke.split(",");

                                    for(var it = 0; it < ids.length; it++)
                                    {
                                        var isIn = false;

                                            for(var st=0; st < dz.umowy[uI].stawki.length; st ++)
                                            {                                        
                                                if( dz.umowy[uI].stawki[st].id == ids[it] )
                                                {                                          
                                                        isIn = true;
                                                }
                                            }

                                            if(!isIn) umAll = false;
                                    } 

                                    if(umAll){
                                        //ta umowa zawiera wszystkie niezbedne stawki..
                                        goAdd3 = 3;
                                    }
                            }                                        
                                                   

                        }                         
                }


                if(filterParam.niezawiera_stawki != "")
                {
                   
                        goAdd4 = false;

                        if(dz.umowy.length  == 0 ) { 
                            goAdd4 = true; //nie ma umowy, nie zawiera zadnej stawki..
                        }else
                        {

                        
                           var umAll = false; //czy zawiera min jedna stawke..
                           goAdd4 = true;

                            for(var uI=0; uI < dz.umowy.length; uI++)
                                {
                                       
                                        var ids = filterParam.niezawiera_stawki.split(",");
    
                                        for(var it = 0; it < ids.length; it++)
                                        {
                                            var isIn = false;
    
                                                for(var st=0; st < dz.umowy[uI].stawki.length; st ++)
                                                {                                        
                                                    if( dz.umowy[uI].stawki[st].id == ids[it] )
                                                    {                                          
                                                        umAll = true;
                                                        console.log("XXX " ,dz.imie, dz.nazwisko, dz.umowy[uI].stawki[st].id,  ids[it] );
                                                    }
                                                }
     
                                        }                                             
                                }
                                
                            if(umAll){                                            
                                    goAdd4 = false;
                                }


                        }
                            
                }


                if(filterParam.stan_umowy != '_x_')
                {
                        goAdd5 = false;

                        if(filterParam.stan_umowy == '_y_')
                        {
                            if(dz.umowy.length == 0) goAdd5 = true;
                        }
                        

                        for(var uI=0; uI < dz.umowy.length; uI++)
                            {
                                  if(dz.umowy[uI].stan_umowy == filterParam.stan_umowy  ) 
                                  {
                                        goAdd5 = true;
                                  }
                            }


                }



                 if(filterParam.archiwalne != '_x_')
                {
                        goAdd8 = false;  

                        if(dz.archiwalne == filterParam.archiwalne  ) 
                         {
                                        goAdd8 = true;
                         }                    
                }


                if( goAdd0 && goAdd1 && goAdd2 && goAdd3 && goAdd4 && goAdd5 && goAdd6 && goAdd7 && goAdd8 )
                {
                    nDz.push( tab[k].dzieci[d] );
                }
            }


            if(nDz.length > 0)
            {
                //var rRow        = new Array();
                //rRow["id"]      = tab[k].id;
                //rRow["nazwa"]   = tab[k].nazwa;
                //rRow["dzieci"]  = nDz;

                var rRow = {
                    id: tab[k].id,
                    nazwa: tab[k].nazwa,
                    dzieci: nDz,
                };
    
                rTab.push(rRow);
            }
                       

        }

        return rTab;
    }




    var itemsStanyUmowy = [
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: '_y_',
            title: 'Nie ma żadnej umowy'
        },
        {
            v: '1',
            title: 'Umowa zawarta, generuj rozliczenia'
        },
        {
            v: '2',
            title: 'Umowa rozwiązana/zakończona'
        },
        {
            v: '3',
            title: 'Umowa czeka na podpis'
        },
    ];




    
    if(tab == null)
        {
            setTab([]);
            getTab();
        

            return <div>
                ...
            </div>
        }





        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);           
        }


     var dlg_view = null;



     if(view != 'btn') 
     {

        //-----------------------------------------------------------

     //   console.log(filterParam);

        var rTab = getFilteredTab();


        
        //-----------------------------------------------------------




        var dlg_view =  (

            <div className="dlg_window dlg_type_xxx shadowx">
    
                    <div className="dlg_title">
                         Wybierz dzieci
                    </div>
    



                    <div className="table_filter">
                      

                            <div className="filter_controll">   
                                <label>Grupa: </label>                             
                                <InputComboGrupa   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Archiwalne: "}   />
                            </div> 

                            <div className="filter_controll">   
                                <label>Archiwalne: </label>                             
                                <InputCombo  items={ [ {v:'_x_',title:'- - - '},  {v:'0',title:'Aktywne'},  {v:'1',title:'W archiwum'},   ]  }  userData={props.userData}  mainView={props.mainView}  value={filterParam.archiwalne}   valChange={valChangeListener} goNext={goNextNew} name="archiwalne"    />
                            </div> 

                            <div className="filter_controll">   
                                        <label>Imię dziecka: </label>                             
                                        <InputTextAlpha   userData={props.userData} value={filterParam.imie}   valChange={valChangeListener} goNext={goNextNew} name="imie" placeholder={"Imię: "}   />
                           </div>  

                            <div className="filter_controll">   
                                        <label>Nazwisko dziecka: </label>                             
                                        <InputTextAlpha   userData={props.userData} value={filterParam.nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="nazwisko" placeholder={"Nazwisko: "}   />
                            </div> 

                            
                            <div className="filter_controll">   
                                        <label>Imię rodzica: </label>                             
                                        <InputTextAlpha   userData={props.userData} value={filterParam.imie_r}   valChange={valChangeListener} goNext={goNextNew} name="imie_r" placeholder={"Imię: "}   />
                           </div>  

                            <div className="filter_controll">   
                                        <label>Nazwisko rodzica: </label>                             
                                        <InputTextAlpha   userData={props.userData} value={filterParam.nazwisko_r}   valChange={valChangeListener} goNext={goNextNew} name="nazwisko_r" placeholder={"Nazwisko: "}   />
                            </div> 

                            
                            <div className="filter_controll">   
                                <label>Stan umowy: </label>                             
                                <InputCombo  items={itemsStanyUmowy}  userData={props.userData}  mainView={props.mainView}  value={filterParam.stan_umowy}   valChange={valChangeListener} goNext={goNextNew} name="stan_umowy"    />
                            </div> 


                            <div className="filter_controll ">   
                                <label>MA przypisane wszystkie stawki: </label>                             
                                <InputComboStawkiWyzMulti  value={filterParam.zawiera_stawke}    userData={props.userData}  mainView={props.mainView}    valChange={valChangeListener} goNext={goNextNew} name="zawiera_stawke"    />
                            </div> 


                            <div className="filter_controll ">   
                                <label>NIE MA przypisanej żadnej stawki: </label>                             
                                <InputComboStawkiWyzMulti  value={filterParam.niezawiera_stawki}    userData={props.userData}  mainView={props.mainView}    valChange={valChangeListener} goNext={goNextNew} name="niezawiera_stawki"    />
                            </div> 

                             


                    </div>
    




                    <div className="dlg_content_x">
    
    
                                      <div className="xselect_multi">
                                        {
                                            rTab.map( (gr, gi) => {
                                                return <div >

                                                     {
                                                          maxKids != 1 &&
                                                         <strong>{gr.nazwa} <sup className="link_color"  id={gr.id} onClick={selectAll}>zaznacz</sup>   </strong>
                                                     }
                                                     
                                                     
                                                     <ul>
                                                            {
                                                                gr.dzieci.map( (dz, di) => {

                                                                      //  var um = "";
                                                                      //  if(dz.umowa.length > 2) um = ", umowa: "+dz.umowa+" ";

                                                                        var css = '';

                                                                        if(dz.param1 == '1') css ="selected";

                                                                        var infoArch = null;
                                                                        if(dz.archiwalne == "1") infoArch = <sup className="gobold red_cg" title="Dziecko w archiwum">[a!]</sup>;

                                                                        return <li className={css}>
                                                                            <div className="xselect_t_content"  p_grupa_id={gr.id} p_dziecko_id={dz.id} onClick={goSelect}>
                                                                                { dz.nazwisko + " " + dz.imie } {infoArch} <br/>
                                                                                <Fragment>r:&nbsp;
                                                                                    {
                                                                                        dz.rodzice.map( (rr, inxRR) => {

                                                                                            if(rr.prowadzenie_salda == 0) return null;

                                                                                             return <Fragment>
                                                                                                {rr.nazwisko} {rr.imie}
                                                                                             </Fragment>
                                                                                        } )
                                                                                    }
                                                                                </Fragment>
                                                                            </div>
                                                                            </li>
                                                                } ) 

                                                            }
                                                     </ul>
                                                     
                                                </div>
                                            } )
                                        }
                                      </div>  
    
                                        <br/>    
                                        <br/>   
    
                                        <div className="form_control">                                            
                                            <div className="btn" onClick={saveData}>zapisz</div>
                                            &nbsp; &nbsp;
                                            <div className="btn" onClick={changeView}>anuluj</div>
                                        </div>
    
                    </div>
    
                
            </div>
    );

    }
   
    
    var info = '';
    var ilosc = null;


 

    if(tabSelected.length == 0)
    {
        info = <div onClick={changeView} className="link_bad">Nie wybrano żadnego dziecka</div>; ;
    }else
    {
            ilosc = <div>
                <strong>wybranych dzieci: {tabSelected.length}</strong>
            </div>
    }


    if(props.info != undefined)
        {
            info = props.info;  
        }

    var titleX = "wybierz dzieci";
    if(props.max != undefined && props.max == 1)
    {
        titleX = "wybierz dziecko";  
    }

    
    return  <div>

                <br/>
                <div className="btn"    onClick={changeView} >{titleX}</div> 

                <div className="xselect">
                    {ilosc}
                 
                        {
                            tabSelected.map( (r, ix) => {
                                return <div className="xselect_item"  onClick={changeView} >
                                        <div className="xselect_t_content">
                                           <span  onClick={changeView}> {r.nazwisko} {r.imie}  </span>
                                           <sup className="link_color" id={r.id} imie={r.imie} nazwisko={r.nazwisko} onClick={reviewKid} title="podgląd" >&nbsp; [p]</sup>
                                        </div>                                        
                                    </div>
                            } )
                        }

                        {info}

                        
                </div>


                {dlg_view} 
           </div>
}



export default InputKidsMulti;